import { render, staticRenderFns } from "./ObjectEdit.vue?vue&type=template&id=44d2b96f"
import script from "./ObjectEdit.vue?vue&type=script&lang=ts"
export * from "./ObjectEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports